window.productAnalytics = {
  track: function (name, properties) {
    try {
      if (window.amplitudeQueue) window.amplitudeQueue.push([name, properties]);
      else if (window.amplitude) window.amplitude.track(name, properties);
    } catch (_error) {}

    try {
      if (window.posthog) window.posthog.capture(name, properties);
    } catch (_error) {}
  },
};
